import IsLoadingHOC from "components/Loader/IsLoadingHOC";

export const getComponentWithLoading = (wrappedComponent) => {
  return IsLoadingHOC(wrappedComponent);
};
